<template>
  <div>
    <section class="xs-banner service-banner contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-5 align-self-center">
            <div class="xs-banner-content">
              <h2 class="banner-title wow fadeInLeft" data-wow-duration="1.5s">PRICING</h2>
              <ul class="breadcrumbs list-inline wow fadeInLeft" data-wow-duration="2s">
                <li><a href="https://episcloud.com">Home</a></li>
                <li>Pricing</li>
              </ul>
              <p class="wow fadeInUp" data-wow-duration="1.5s"></p>
            </div><!-- .xs-banner-content END -->
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="inner-welcome-image-group">
              <img src="../assets/images/pricing.png" alt="Welcome banner image">
              <img src="../assets/images/dollar.png" class="banner-ico banner-ico-1"
                   alt="banner icon"><img src="../assets/images/euro.png"
                                          class="banner-ico banner-ico-2" alt="banner icon"></div>
          </div>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-600" class="full-width-content post-600 page type-page status-publish hentry">
          <div data-elementor-type="wp-post" data-elementor-id="600"
               class="elementor elementor-600 elementor-bc-flex-widget" data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-2690de2 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="2690de2" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-772b5ef"
                        data-id="772b5ef" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-60f310d"
                        data-id="60f310d" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-7d8b806 elementor-widget elementor-widget-xs-heading"
                              data-id="7d8b806" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Best Hosting</h3>
                                  <h2 class="heading-title">WHY <span>CHOOSE US</span></h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-585abc9"
                        data-id="585abc9" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-d186241 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="d186241" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-af7e844 animated-slow animated fadeInUp"
                        data-id="af7e844" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:0.7}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-d8c0e9d elementor-widget elementor-widget-xs-image-box"
                              data-id="d8c0e9d" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-1.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">99.9% Uptime Guarantee</h4>
                                  <p>Share processes and data secure
                                    lona need to know basis</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-82eda63 animated-slow animated fadeInUp"
                        data-id="82eda63" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:1.5}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-6d96648 elementor-widget elementor-widget-xs-image-box"
                              data-id="6d96648" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-2.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Safe and Secured</h4>
                                  <p>Our team assured your web site is always safe and secure</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-923a80d animated-slow animated fadeInUp"
                        data-id="923a80d" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:2}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-889caab elementor-widget elementor-widget-xs-image-box"
                              data-id="889caab" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-3.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Our Dedicated Support</h4>
                                  <p>We finally found a host that truly understood the unique</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <div
                  class="elementor-section elementor-top-section elementor-element elementor-element-5fa17d9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="5fa17d9" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-9150216"
                        data-id="9150216" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-section elementor-inner-section elementor-element elementor-element-058bc39 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="058bc39" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b9925b6"
                                    data-id="b9925b6" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-bd60680"
                                    data-id="bd60680" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-7a09102 elementor-widget elementor-widget-xs-heading"
                                          data-id="7a09102" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">Pricing Plans</h3>
                                              <h2 class="heading-title">OUR <span>BEST PRICING</span></h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-665f335"
                                    data-id="665f335" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-6e4cfef elementor-widget elementor-widget-xs-price"
                              data-id="6e4cfef" data-element_type="widget" data-widget_type="xs-price.default">
                              <div class="elementor-widget-container">
                                <div class="xs-pricing-group">
                                  <ul class="nav nav-tabs main-nav-tab tab-swipe" role="tablist">
                                    <li>
                                      <a id="monthly-tab" class="active show" data-toggle="tab"
                                         href="#monthly">Monthly</a>
                                    </li>
                                    <li>
                                      <a id="yearly-tab" data-toggle="tab" href="#yearly">Yearly</a>
                                    </li>
                                    <li class="indicator" style="left: 5px; width: 125px;"></li>
                                  </ul>
                                  <div class="tab-content">
                                    <div class="tab-pane fadeIn animated show active" id="monthly">
                                      <div class="row">
                                        <div class="grid col-lg-4 col-md-6">
                                          <div class="xs-single-pricing ">
                                            <div class="pricing-header">
                                              <div class="pricing-img-block">
                                                <img
                                                  src="../assets/images/pricing_image.png"
                                                  alt="" draggable="false">
                                              </div>
                                              <h4 class="xs-title">Cloud Hosting</h4>
                                            </div><!-- .pricing-header END -->

                                            <div class="pricing-body">
                                              <p>The High performance cloud platform ever</p>

                                              <div class="pricing-price">
                                                <p>Starting at</p>
                                                <h2>
                                                  <sup>$</sup>49 </h2>

                                                <h6 class="discount-price">25% Discount
                                                  <del>$49.99</del>
                                                </h6>
                                              </div>
                                            </div><!-- .pricing-body END -->
                                            <div class="pricing-footer">
                                              <a href="" target="_self" class="btn btn-primary">Buy Now</a>
                                            </div><!-- .pricing-footer END -->
                                          </div><!-- .xs-single-pricing END -->
                                        </div>
                                        <div class="grid col-lg-4 col-md-6">
                                          <div class="xs-single-pricing active">
                                            <div class="pricing-header">
                                              <div class="pricing-img-block">
                                                <img
                                                  src="../assets/images/pricing_image.png"
                                                  alt="" draggable="false">
                                              </div>
                                              <h4 class="xs-title">VPS Hosting</h4>
                                            </div><!-- .pricing-header END -->

                                            <div class="pricing-body">
                                              <p>The ideal solution for corporate websites and larger blogs</p>

                                              <div class="pricing-price">
                                                <p>Starting at</p>
                                                <h2>
                                                  <sup>$</sup>39 </h2>

                                                <h6 class="discount-price">25% Discount
                                                  <del>$108.99</del>
                                                </h6>
                                              </div>
                                            </div><!-- .pricing-body END -->
                                            <div class="pricing-footer">
                                              <a href="" target="_self" class="btn btn-primary">Buy Now</a>
                                            </div><!-- .pricing-footer END -->
                                          </div><!-- .xs-single-pricing END -->
                                        </div>
                                        <div class="grid col-lg-4 col-md-6">
                                          <div class="xs-single-pricing ">
                                            <div class="pricing-header">
                                              <div class="pricing-img-block">
                                                <img
                                                  src="../assets/images/pricing_image.png"
                                                  alt="" draggable="false">
                                              </div>
                                              <h4 class="xs-title">Shared Hosting</h4>
                                            </div><!-- .pricing-header END -->

                                            <div class="pricing-body">
                                              <p>The High performance cloud platform ever</p>

                                              <div class="pricing-price">
                                                <p>Starting at</p>
                                                <h2>
                                                  <sup>$</sup>17 </h2>

                                                <h6 class="discount-price">25% Discount
                                                  <del>$29.99</del>
                                                </h6>
                                              </div>
                                            </div><!-- .pricing-body END -->
                                            <div class="pricing-footer">
                                              <a href="" target="_self" class="btn btn-primary">Buy Now</a>
                                            </div><!-- .pricing-footer END -->
                                          </div><!-- .xs-single-pricing END -->
                                        </div>
                                      </div>
                                    </div>
                                    <div class="tab-pane fadeIn animated" id="yearly">
                                      <div class="row">
                                        <div class="grid col-lg-4 col-md-6">
                                          <div class="xs-single-pricing ">
                                            <div class="pricing-header">
                                              <div class="pricing-img-block">
                                                <img
                                                  src="../assets/images/pricing_image.png"
                                                  alt="" draggable="false">
                                              </div>
                                              <h4 class="xs-title">Dedicated Server</h4>
                                            </div><!-- .pricing-header END -->

                                            <div class="pricing-body">
                                              <p>The High performance cloud platform ever</p>

                                              <div class="pricing-price">
                                                <p></p>
                                                <h2>
                                                  <sup>$</sup>29.99 </h2>

                                                <h6 class="discount-price">25% Discount
                                                  <del>$29.99</del>
                                                </h6>
                                              </div>
                                            </div><!-- .pricing-body END -->
                                            <div class="pricing-footer">
                                              <a href="" target="_self" class="btn btn-primary">Buy Now</a>
                                            </div><!-- .pricing-footer END -->
                                          </div><!-- .xs-single-pricing END -->
                                        </div>
                                        <div class="grid col-lg-4 col-md-6">
                                          <div class="xs-single-pricing active">
                                            <div class="pricing-header">
                                              <div class="pricing-img-block">
                                                <img
                                                  src="../assets/images/pricing_image.png"
                                                  alt="" draggable="false">
                                              </div>
                                              <h4 class="xs-title">Reseller Hosting</h4>
                                            </div><!-- .pricing-header END -->

                                            <div class="pricing-body">
                                              <p>The High performance cloud platform ever</p>

                                              <div class="pricing-price">
                                                <p></p>
                                                <h2>
                                                  <sup>$</sup>29.99 </h2>

                                                <h6 class="discount-price">25% Discount
                                                  <del>$29.99</del>
                                                </h6>
                                              </div>
                                            </div><!-- .pricing-body END -->
                                            <div class="pricing-footer">
                                              <a href="" target="_self" class="btn btn-primary">Buy Now</a>
                                            </div><!-- .pricing-footer END -->
                                          </div><!-- .xs-single-pricing END -->
                                        </div>
                                        <div class="grid col-lg-4 col-md-6">
                                          <div class="xs-single-pricing ">
                                            <div class="pricing-header">
                                              <div class="pricing-img-block">
                                                <img
                                                  src="../assets/images/pricing_image.png"
                                                  alt="" draggable="false">
                                              </div>
                                              <h4 class="xs-title">Shared Hosting</h4>
                                            </div><!-- .pricing-header END -->

                                            <div class="pricing-body">
                                              <p>The High performance cloud platform ever</p>

                                              <div class="pricing-price">
                                                <p></p>
                                                <h2>
                                                  <sup>$</sup>29.99 </h2>

                                                <h6 class="discount-price">25% Discount
                                                  <del>$29.99</del>
                                                </h6>
                                              </div>
                                            </div><!-- .pricing-body END -->
                                            <div class="pricing-footer">
                                              <a href="" target="_self" class="btn btn-primary">Buy Now</a>
                                            </div><!-- .pricing-footer END -->
                                          </div><!-- .xs-single-pricing END -->
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-5dd452a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="5dd452a" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2f4e642"
                        data-id="2f4e642" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-2fbac23 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="2fbac23" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-7a72932"
                                    data-id="7a72932" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-2de339c elementor-widget elementor-widget-heading"
                                          data-id="2de339c" data-element_type="widget"
                                          data-widget_type="heading.default">
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">Features
                                              Comparision</h2></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <div
                              class="elementor-element elementor-element-f3c17fb elementor-widget elementor-widget-xs-pricing-table"
                              data-id="f3c17fb" data-element_type="widget" data-widget_type="xs-pricing-table.default">
                              <div class="elementor-widget-container">
                                <div class="pricing-matrix pricing-expand wow fadeIn" data-height="1046px"
                                     data-min="515px" style="height: 515px; visibility: hidden; animation-name: none;">
                                  <div class="row no-gutters">
                                    <div class="col-lg-3">
                                      <div class="pricing-matrix-item">
                                        <div class="d-lg-block d-md-none d-none">
                                          <div class="pricing-image border-bottom-0" style="height: 350px;">
                                            <img
                                              src="../assets/images/pricing_img-1.png"
                                              alt="pricing image" draggable="false">
                                          </div>
                                          <div class="gap"></div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Visits per month </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Total Sites </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Hosting type </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Shared </span>
                                          </div>
                                          <div class="pricing-feature-item border-bottom-0">
                                            <span class="pricing-feature">Bandwidth per month </span>
                                          </div>
                                          <div class="gap"></div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Dev, Stage, Prod </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Transferable Sites </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">Multisite ready </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">PHP 7 ready </span>
                                          </div>
                                          <div class="pricing-feature-item">
                                            <span class="pricing-feature">LargeFS </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-lg-9">
                                      <div class="pricing-matrix-slider owl-carousel owl-loaded">


                                        <div class="owl-stage-outer">
                                          <div class="owl-stage"
                                               style="transform: translate3d(0px, 0px, 0px); transition: all 0s ease 0s; width: 840px;">
                                            <div class="owl-item active" style="width: 280px;">
                                              <div class="pricing-matrix-item">
                                                <div class="pricing-feature-group border-bottom-0">
                                                  <h4 class="xs-title">Regular</h4>
                                                  <div class="pricing-body">
                                                    <p>The High performance cloud platform ever</p>
                                                    <div class="pricing-price">
                                                      <h2>
                                                        <sup>$</sup>
                                                        29 <span>/month</span>
                                                      </h2>
                                                    </div>
                                                    <a href="" target="_self" class="btn btn-primary">Buy Now</a>
                                                  </div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Visits per month
                                                  </div>
                                                  <div class="pricing-feature">Up to 25000</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Total Sites</div>
                                                  <div class="pricing-feature">1</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Hosting type</div>
                                                  <div class="pricing-feature">Shared</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Shared</div>
                                                  <div class="pricing-feature">50 GB</div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Bandwidth per
                                                    month
                                                  </div>
                                                  <div class="pricing-feature">256 GB</div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Dev, Stage, Prod
                                                  </div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Transferable Sites
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Multisite ready
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">PHP 7 ready</div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">LargeFS</div>
                                                  <div class="pricing-feature"></div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="owl-item active" style="width: 280px;">
                                              <div class="pricing-matrix-item">
                                                <div class="pricing-feature-group border-bottom-0">
                                                  <h4 class="xs-title">Standard</h4>
                                                  <div class="pricing-body">
                                                    <p>The High performance cloud platform ever</p>
                                                    <div class="pricing-price">
                                                      <h2>
                                                        <sup>$</sup>
                                                        39 <span>/month</span>
                                                      </h2>
                                                    </div>
                                                    <a href="" target="_self" class="btn btn-primary">Buy Now</a>
                                                  </div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Visits per month
                                                  </div>
                                                  <div class="pricing-feature">Up to 50000</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Total Sites</div>
                                                  <div class="pricing-feature">3</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Hosting type</div>
                                                  <div class="pricing-feature">Shared</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Shared</div>
                                                  <div class="pricing-feature">100 GB</div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Bandwidth per
                                                    month
                                                  </div>
                                                  <div class="pricing-feature">512 GB</div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Dev, Stage, Prod
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Transferable Sites
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Multisite ready
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">PHP 7 ready</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">LargeFS</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="owl-item active last-child" style="width: 280px;">
                                              <div class="pricing-matrix-item">
                                                <div class="pricing-feature-group border-bottom-0">
                                                  <h4 class="xs-title">Plus</h4>
                                                  <div class="pricing-body">
                                                    <p>The High performance cloud platform ever</p>
                                                    <div class="pricing-price">
                                                      <h2>
                                                        <sup>$</sup>
                                                        49 <span>/month</span>
                                                      </h2>
                                                    </div>
                                                    <a href="" target="_self" class="btn btn-primary">Buy Now</a>
                                                  </div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Visits per month
                                                  </div>
                                                  <div class="pricing-feature">Unlimited</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Total Sites</div>
                                                  <div class="pricing-feature">5</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Hosting type</div>
                                                  <div class="pricing-feature">Shared</div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Shared</div>
                                                  <div class="pricing-feature">500 GB</div>
                                                </div>
                                                <div class="pricing-feature-item border-bottom-0">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Bandwidth per
                                                    month
                                                  </div>
                                                  <div class="pricing-feature">1 TB</div>
                                                </div>
                                                <div class="gap"></div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Dev, Stage, Prod
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Transferable Sites
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">Multisite ready
                                                  </div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">PHP 7 ready</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                                <div class="pricing-feature-item">
                                                  <div class="pricing-feature d-lg-none d-sm-block">LargeFS</div>
                                                  <div class="pricing-feature"><i class="fa fa-check"></i></div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="owl-nav disabled">
                                          <div class="owl-prev disabled"><i class="icon icon-arrow-right"></i></div>
                                          <div class="owl-next disabled"><i class="icon icon-arrow-left"></i></div>
                                        </div>
                                        <div class="owl-dots disabled"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="content-collapse-wraper"><a href="#" class="btn btn-primary expand-btn">Load
                                  More <i class="icon icon-arrow_down"></i></a></div>
                                <input type="hidden" name="load_more_text" title="Load More" id="load_more_text"
                                       autocomplete="off" autocorrect="off">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-a651412 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="a651412" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-9218856"
                        data-id="9218856" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-9c46125 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="9c46125" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-0e65d40"
                                    data-id="0e65d40" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-c941537"
                                    data-id="c941537" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-6d968b9 elementor-widget elementor-widget-xs-heading"
                                          data-id="6d968b9" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">Questions</h3>
                                              <h2 class="heading-title">PACKAGES <span>INCLUDE</span></h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-3656231"
                                    data-id="3656231" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-1629898 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="1629898" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-2dd72fc"
                                    data-id="2dd72fc" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-4615f06 elementor-widget elementor-widget-toggle"
                                          data-id="4615f06" data-element_type="widget"
                                          data-widget_type="toggle.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-toggle" role="tablist">
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-7341" class="elementor-tab-title"
                                                     data-tab="1" role="tab" aria-controls="elementor-tab-content-7341"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">Do you offer managed
                                                    hosting?</a>
                                                </div>

                                                <div id="elementor-tab-content-7341"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="1"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-7341">No, its
                                                  completely unmanaged — if you experience issues with your server, you
                                                  can reach out to our support team.
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-7342" class="elementor-tab-title"
                                                     data-tab="2" role="tab" aria-controls="elementor-tab-content-7342"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How to buy a domain in cheap
                                                    price?</a>
                                                </div>

                                                <div id="elementor-tab-content-7342"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="2"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-7342">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-7343" class="elementor-tab-title"
                                                     data-tab="3" role="tab" aria-controls="elementor-tab-content-7343"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I set up a URL
                                                    redirect for a domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-7343"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="3"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-7343">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-7344" class="elementor-tab-title"
                                                     data-tab="4" role="tab" aria-controls="elementor-tab-content-7344"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How can I change the
                                                    nameservers for my domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-7344"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="4"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-7344">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-7345" class="elementor-tab-title"
                                                     data-tab="5" role="tab" aria-controls="elementor-tab-content-7345"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I generate a CSR
                                                    code?</a>
                                                </div>

                                                <div id="elementor-tab-content-7345"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="5"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-7345">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                                                  Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid
                                                  single-origin.
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-4d66b05"
                                    data-id="4d66b05" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-3b884f4 elementor-widget elementor-widget-toggle"
                                          data-id="3b884f4" data-element_type="widget"
                                          data-widget_type="toggle.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-toggle" role="tablist">
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-6241" class="elementor-tab-title"
                                                     data-tab="1" role="tab" aria-controls="elementor-tab-content-6241"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How to set up Free Email
                                                    Forwarding</a>
                                                </div>

                                                <div id="elementor-tab-content-6241"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="1"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-6241">No, its
                                                  completely unmanaged — if you experience issues with your server, you
                                                  can reach out to our support team.
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-6242" class="elementor-tab-title"
                                                     data-tab="2" role="tab" aria-controls="elementor-tab-content-6242"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I transfer a
                                                    domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-6242"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="2"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-6242">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-6243" class="elementor-tab-title"
                                                     data-tab="3" role="tab" aria-controls="elementor-tab-content-6243"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How to transfer an existing
                                                    hosting account?</a>
                                                </div>

                                                <div id="elementor-tab-content-6243"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="3"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-6243">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-6244" class="elementor-tab-title"
                                                     data-tab="4" role="tab" aria-controls="elementor-tab-content-6244"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title">How do I renew my
                                                    domain?</a>
                                                </div>

                                                <div id="elementor-tab-content-6244"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="4"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-6244">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod
                                                  brunch
                                                </div>
                                              </div>
                                              <div class="elementor-toggle-item">
                                                <div id="elementor-tab-title-6245" class="elementor-tab-title"
                                                     data-tab="5" role="tab" aria-controls="elementor-tab-content-6245"
                                                     aria-expanded="false">
												<span class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true">
															<i class="elementor-toggle-icon-closed icon icon-down-arrow"></i>
								<i class="elementor-toggle-icon-opened icon icon-up-arrow"></i>
													</span>
                                                  <a href="" class="elementor-toggle-title"> How does WhoisGuard work
                                                    for keep secure? </a>
                                                </div>

                                                <div id="elementor-tab-content-6245"
                                                     class="elementor-tab-content elementor-clearfix" data-tab="5"
                                                     role="tabpanel" aria-labelledby="elementor-tab-title-6245">Anim
                                                  pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                                  richardson ad squid. 3 wolf moon officia aute, non cupidatat
                                                  skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                                                  Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid
                                                  single-origin.
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-d6628d5 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="d6628d5" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-62ea642"
                        data-id="62ea642" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-3097b73 elementor-widget elementor-widget-xs-testimonial"
                              data-id="3097b73" data-element_type="widget" data-widget_type="xs-testimonial.default">
                              <div class="elementor-widget-container">
                                <div class="xs-testimonial-slider owl-carousel owl-loaded owl-drag">

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <!-- Testimonial Content End -->

                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transition: all 0s ease 0s; width: 3834px; transform: translate3d(-766px, 0px, 0px);">
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-4-55x55.jpg"
                                                  alt="avatar-4" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active center" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-3-55x55.png"
                                                  alt="avatar-3" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-4-55x55.jpg"
                                                  alt="avatar-4" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-3-55x55.png"
                                                  alt="avatar-3" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Joe D Walczak</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-2-55x55.png"
                                                  alt="avatar-2" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Richard I Jones</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 353.333px; margin-right: 30px;">
                                        <div class="xs-testimonial-item">
                                          <div class="testimonial-content">
                                            <p>Our best-in-class WordPress solution with additio nal optiz ation to make
                                              an running a WooCommerce</p>
                                            <div class="commentor-bio media">
                                              <div class="d-flex round-avatar">
                                                <img
                                                  src="../assets/images/avatar-1-55x55.png"
                                                  alt="avatar-1" class="img-fluid" draggable="false">
                                              </div>
                                              <div class="media-body align-self-center">
                                                <h4 class="commentor-title">Cecilia H King</h4>
                                                <p class="commentor-info">CEO, Pranklin Agency</p>
                                                <i class="icon icon-quote"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-ef98371 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="ef98371" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-23b5745"
                        data-id="23b5745" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-0867580 elementor-widget elementor-widget-xs-partner"
                              data-id="0867580" data-element_type="widget" data-widget_type="xs-partner.default">
                              <div class="elementor-widget-container">
                                <div class="xs-client-slider owl-carousel owl-loaded owl-drag">


                                  <div class="owl-stage-outer">
                                    <div class="owl-stage"
                                         style="transform: translate3d(-1120px, 0px, 0px); transition: all 0s ease 0s; width: 3360px;">
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item active" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-1.png"
                                            alt="client-1" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-2.png"
                                            alt="client-2" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-3.png"
                                            alt="client-3" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-4.png"
                                            alt="client-4" draggable="false"></a>
                                        </div>
                                      </div>
                                      <div class="owl-item cloned" style="width: 224px;">
                                        <div class="single-client">
                                          <a href="" target="_self"> <img
                                            src="../assets/images/client-5.png"
                                            alt="client-5" draggable="false"></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="owl-nav disabled">
                                    <div class="owl-prev"></div>
                                    <div class="owl-next"></div>
                                  </div>
                                  <div class="owl-dots disabled"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-20eb49d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="20eb49d" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-cae3056 animated-slow animated fadeInLeft"
                        data-id="cae3056" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-d1299d0 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="d1299d0" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138"
                                           src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a3396ca animated-slow animated fadeInRight"
                        data-id="a3396ca" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-96fe986 elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="96fe986" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138"
                                           src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-d11478d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="d11478d" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-a9269fd"
                        data-id="a9269fd" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-7fbf698 elementor-widget elementor-widget-spacer"
                              data-id="7fbf698" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'Pricing'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Pricing.vue